export default function () {
  const widgetName = 'cardWidget';
  const widgetOpts = cardWidgetOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: true,
      text: 'BUY NOW',
    },
    cardWidgetLoaded: function () {
      // arguments: data, owl, hasData
      $(`#${widgetName} a`).removeAttr('target');

      setTimeout(function () {
        $(`#${widgetName} a.card-widget-item.void-link`).each(function () {
          if ($(this).find('.buttonwrap .buyNowButton').length > 0) {
            $(this).removeClass('void-link');
          }
        });
      }, 4000);

      function removeAttrtag() {
        $(`.saffireLargeSize #${widgetName} .card-widget-item`).removeAttr('href');
        $(`.saffireMobileSize #${widgetName} .card-widget-item.void-link`).removeAttr('href');
      }

      $(document).ready(() => {
        removeAttrtag();
      });
      $(window).resize(() => {
        removeAttrtag();
      });
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    link: ['all'], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 8,
    moreButton: {
      visible: true,
      text: 'MORE',
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: true,
  });
}
